import { newApiFetchV2 } from "./utils";

type ISearchInterestData = {
  data: Array<{ market: string }>;
};

export const getSearchInterestData = (): Promise<ISearchInterestData> => newApiFetchV2("/search_interest/brand_model/get", {});
